<template>
  <v-container>
    <BasePanelWithHeader headerText="Import New Bills">
      <template v-slot:content>
        <v-row v-if="userAdminAgencies.length > 1">
          <v-col>
            <LuAgency
              v-model="selectedAgency"
              :items="userAdminAgencies"
              return-object
            ></LuAgency>
          </v-col>
        </v-row>
        <div v-show="selectedAgency.ID > 0">
          <v-row>
            <v-col cols="12" sm="auto" class="mt-4 mr-4">
              <div class="mb-5">
                This action will retrieve all bills from the Legislature website
                for the most recent session and add any that do not exist for

                {{ selectedAgency.Name }} and add tracked bills for them.
              </div>
              <BaseTooltipButton
                small
                @click="importBills()"
                icon="mdi-import"
                iconColor="white"
                :iconButton="false"
                buttonClass="primary"
                buttonRightText="Retrieve all new bills"
                >Import New Bills
              </BaseTooltipButton>
            </v-col>
          </v-row>
        </div>
      </template>
    </BasePanelWithHeader>
  </v-container>
</template>
<script>
import { authComputed } from '@state/helpers'
import { get, sync, commit, call } from 'vuex-pathify'
import LuAgency from '@components/select/single/LuAgency'
export default {
  page: {
    title: '',
  },
  //model: {
  //	prop: ''
  //},
  props: {},
  components: { LuAgency },
  filters: {},
  data() {
    return {
      selectedAgency: {},
    }
  },
  created() {
    if (this.userAdminAgencies.length == 1) {
      this.selectedAgency = this.userAdminAgencies[0]
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...call('messages', ['toastMessage']),
    handleError: call('errors/handleError'),
    async importBills() {
      let selectedAgencyId = this.selectedAgency.ID
      if (selectedAgencyId > 0) {
        var url = `TrackedBill/GetNewBillsAndAddAll/${selectedAgencyId}`
        try {
          let { data } = await this.$axios.get(url)
          this.toastMessage(data.msg)
        } catch (err) {
          this.handleError(err)
        }
      }
    },
  },
  watch: {},
}
</script>
<style scoped></style>
